import Description from 'components_v1/ClassView/Description'
import React from 'react'

const CoachBio = ({ coachInfo }) => {
  return (
    <div className='profile-header'>
      <div className='profile-table'>
        <div className='profile-table-left'>
          <div className='profile-photo'>
            <img
              src={coachInfo.photoUrl}
              alt={`${coachInfo.name}'s Online Workout Videos on ALO Wellness Club`}
              className='profile-photo-image img-circle'
            />
          </div>
        </div>

        <div className='profile-table-right'>
          {coachInfo.bio && (
            <div className='profile-bio-container'>
              <div>
                <Description
                  className='profile-bio'
                  description={coachInfo?.bio}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CoachBio
